var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#9D9D9D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    clipPath: "url(#clip0_721_23627)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 944,
    transform: "translate(-911 -733)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8399",
    x: -636.5,
    y: -139.5,
    width: 666,
    height: 330,
    rx: 5.5,
    fill: "white",
    stroke: "#E6EDF0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000015361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union",
    filter: "url(#filter0_d_721_23627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_721_23627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.54 -667L319.148 -677L310.042 -667H-26C-28.2091 -667 -30 -665.209 -30 -663V112C-30 114.209 -28.2091 116 -26 116H416C418.209 116 420 114.209 420 112V-663C420 -665.209 418.209 -667 416 -667H327.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.54 -667L319.148 -677L310.042 -667H-26C-28.2091 -667 -30 -665.209 -30 -663V112C-30 114.209 -28.2091 116 -26 116H416C418.209 116 420 114.209 420 112V-663C420 -665.209 418.209 -667 416 -667H327.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.148 -677L319.914 -677.643L319.179 -678.519L318.409 -677.673L319.148 -677ZM327.54 -667L326.774 -666.357L327.074 -666H327.54V-667ZM310.042 -667V-666H310.484L310.781 -666.327L310.042 -667ZM318.382 -676.357L326.774 -666.357L328.306 -667.643L319.914 -677.643L318.382 -676.357ZM310.781 -666.327L319.888 -676.327L318.409 -677.673L309.303 -667.673L310.781 -666.327ZM-26 -666H310.042V-668H-26V-666ZM-29 -663C-29 -664.657 -27.6569 -666 -26 -666V-668C-28.7614 -668 -31 -665.761 -31 -663H-29ZM-29 112V-663H-31V112H-29ZM-26 115C-27.6569 115 -29 113.657 -29 112H-31C-31 114.761 -28.7614 117 -26 117V115ZM416 115H-26V117H416V115ZM419 112C419 113.657 417.657 115 416 115V117C418.761 117 421 114.761 421 112H419ZM419 -663V112H421V-663H419ZM416 -666C417.657 -666 419 -664.657 419 -663H421C421 -665.761 418.761 -668 416 -668V-666ZM327.54 -666H416V-668H327.54V-666Z",
    fill: "#F0F0F0",
    mask: "url(#path-2-inside-1_721_23627)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000015213",
    clipPath: "url(#clip1_721_23627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000015215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flags"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#667085",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.1662 15.6388C7.54066 16.1088 8.09055 16.413 8.69417 16.484C9.29779 16.5551 9.90538 16.3871 10.3824 16.0173C10.5292 15.9079 10.6612 15.7808 10.7754 15.6388M2.62562 10.3403V10.1761C2.64971 9.69018 2.80545 9.21937 3.07677 8.8122C3.52838 8.3231 3.83753 7.72373 3.97179 7.07698C3.97179 6.57713 3.97179 6.07013 4.01544 5.57027C4.24102 3.16381 6.62046 1.5 8.97079 1.5H9.02901C11.3793 1.5 13.7588 3.16381 13.9916 5.57027C14.0353 6.07013 13.9916 6.57713 14.028 7.07698C14.1641 7.72523 14.4729 8.32646 14.923 8.81934C15.1964 9.2229 15.3524 9.692 15.3742 10.1761V10.3332C15.3904 10.986 15.1656 11.6226 14.7411 12.1255C14.1802 12.7136 13.4191 13.0795 12.6018 13.1538C10.2052 13.4109 7.78727 13.4109 5.39072 13.1538C4.57436 13.0762 3.81432 12.7109 3.2514 12.1255C2.8335 11.6222 2.61168 10.9894 2.62562 10.3403Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-30 -19H419V-21H-30V-19ZM419 67H-30V69H419V67Z",
    fill: "#F4F4F4",
    mask: "url(#path-4-inside-2_721_23627)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_721_23627",
    x: -58,
    y: -701,
    width: 506,
    height: 849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_721_23627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_721_23627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_23627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 944,
    fill: "white",
    transform: "translate(-911 -733)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_721_23627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 693,
    fill: "white",
    transform: "translate(-30 -577)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.d3a94dcca0dc64309d08dd33a4473101.svg";
export { ForwardRef as ReactComponent };